<!-- Single Archive Result Set: Show just a button. -->
@if (archiveSets === 'single') {
  <button
    mat-button
    class="xl-badge"
    [matTooltip]="archive.name"
    matTooltipShowDelay="1000"
  >
    <mat-icon
      [matBadge]="activeArchiveCount$ | async | compactNumber"
      [matBadgeHidden]="isSearchCountEnabled !== true"
      matBadgePosition="above before"
      >inventory_2</mat-icon
    >
    @if ((useCompactLayout$ | async) === false) {
      <div class="archive-name ellipsis">
        {{ archive.name }}
      </div>
    }
  </button>
}
<!-- Mutliple Archives Result Sets: Show a dropdown menu control. -->
@if (archiveSets === 'multi') {
  <button
    mat-button
    class="xl-badge"
    [matTooltip]="archive.name"
    [matMenuTriggerFor]="archiveSelectMenu"
  >
    <mat-icon
      [matBadge]="activeArchiveCount$ | async | compactNumber"
      [matBadgeHidden]="isSearchCountEnabled !== true"
      matBadgePosition="above before"
      class="chevron-icon"
      >expand_circle_down</mat-icon
    >
    @if ((useCompactLayout$ | async) === false) {
      <div class="archive-name ellipsis">
        {{ archive.name }}
      </div>
    }
  </button>
}
<mat-menu #archiveSelectMenu="matMenu">
  <ng-template matMenuContent>
    <!-- Items for all archives unless hideArchiveWithNoResults is on -->
    @for (archiveResultCount of archiveResultCounts; track archiveResultCount) {
      @if (
        !archiveResultCount.isActive &&
        ((hideArchivesWithNoResults$ | async) === false ||
          archiveResultCount.count()! > 0)
      ) {
        <ng-container
          *ngTemplateOutlet="
            archiveMenuItemTemplate;
            context: { archiveResultCount: archiveResultCount }
          "
        ></ng-container>
      }
    }
    <!-- Items for all still loading archives if hideArchiveWithNoResults is on, to ensure they are at the bottom of the menu -->
    @if ((hideArchivesWithNoResults$ | async) === true) {
      @for (
        archiveResultCount of archiveResultCounts;
        track archiveResultCount
      ) {
        @if (
          !archiveResultCount.isActive &&
          (archiveResultCount.loading$ | async) === true
        ) {
          <ng-container
            *ngTemplateOutlet="
              archiveMenuItemTemplate;
              context: { archiveResultCount: archiveResultCount }
            "
          ></ng-container>
        }
      }
    }
  </ng-template>
</mat-menu>

<ng-template
  #archiveMenuItemTemplate
  let-archiveResultCount="archiveResultCount"
>
  <button
    mat-menu-item
    class="xl-badge"
    [class.archive-menu-item-with-badge]="isSearchCountEnabled"
    (click)="onClickSelectArchive(archiveResultCount.archiveId)"
  >
    @if (
      archiveResultCount.count() === undefined ||
      (archiveResultCount.loading$ | async)
    ) {
      <div class="archive-result-menu-item-spinner" aria-hidden="true">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    } @else {
      <mat-icon
        [matBadge]="archiveResultCount.count() | compactNumber"
        [matBadgeHidden]="isSearchCountEnabled !== true"
        matBadgePosition="above before"
        >inventory_2
      </mat-icon>
    }
    <span class="archive-result-menu-item-name">{{
      archiveResultCount.archiveName
    }}</span>
  </button>
</ng-template>
